<template>
  <van-form
    ref="vanForm"
    validate-first
    class="mode"
    validate-trigger="onChange"
  >
    <van-cell-group>
      <template v-for="(item, key) of form">
        <van-field
          v-if="item.isSelect"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :name="key"
          :rules="item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop(item.name, key)"
        />
        <van-field
          v-else
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :name="key"
          :rules="item.value ? item.rules : []"
          placeholder="请输入"
          @input="val => changeValue(val, key)"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="textList.title"
        show-toolbar
        :columns="textList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, textList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        jtzz: {
          name: "家庭住址",
          text: "",
          value: ""
        },
        jtdh: {
          name: "家庭电话",
          text: "",
          value: "",
          rules: [
            {
              pattern: /\d{1}|\d-\d-\d/,
              message: "请输入正确的电话"
            }
          ]
        },
        jtyzbm: {
          name: "家庭邮政编码",
          text: "",
          value: "",
          rules: [
            {
              pattern: /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/,
              message: "请输入正确的邮政编码"
            }
          ]
        },
        jtdzxx: {
          name: "家庭电子邮箱",
          text: "",
          value: "",
          rules: [
            {
              pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([*.]\w+)*$/,
              message: "请输入正确的电子邮箱"
            }
          ]
        },
        jtlxr: {
          name: "家庭联系人",
          text: "",
          value: ""
        }
      },
      show: false,
      textList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          let params = {
            type: "jtzz",
            jtzz: this.form.jtzz.value,
            jtdh: this.form.jtdh.value,
            jtyzbm: this.form.jtyzbm.value,
            jtdzxx: this.form.jtdzxx.value,
            jtlxr: this.form.jtlxr.value,
            xs0105id: this.info.xs0105id
          };

          const res = await Api.saveXjxx(params);
          if (res.code == 1) {
            if (this.info.type === "add") {
              this.$toast.success("学籍" + this.info.title + "增加已提交");
            } else {
              this.$toast.success("学籍" + this.info.title + "修改已提交");
            }
            setTimeout(() => {
              this.$router.replace(
                "/xsxxxgsq/index?active=" + this.info.active
              );
            }, 1500);
          }
        },
        () => {}
      );
    },
    async getList() {
      const res = await Api.findStudentInfo({
        type: "jtzz",
        xs0105id: this.info.xs0105id
      });
      if (res.code === "1") {
        let message = res.data.jtzzInfo;
        if (this.info.type === "update") {
          this.form = {
            jtzz: {
              name: "家庭住址",
              text: message.jtzz,
              value: message.jtzz
            },
            jtdh: {
              name: "家庭电话",
              text: message.jtdh,
              value: message.jtdh,
              rules: [
                {
                  pattern: /\d{1}|\d-\d-\d/,
                  message: "请输入正确的电话"
                }
              ]
            },
            jtyzbm: {
              name: "家庭邮政编码",
              text: message.jtyzbm,
              value: message.jtyzbm,
              rules: [
                {
                  pattern: /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/,
                  message: "请输入正确的邮政编码"
                }
              ]
            },
            jtdzxx: {
              name: "家庭电子邮箱",
              text: message.jtdzxx,
              value: message.jtdzxx,
              rules: [
                {
                  pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([*.]\w+)*$/,
                  message: "请输入正确的电子邮箱"
                }
              ]
            },
            jtlxr: {
              name: "家庭联系人",
              text: message.jtlxr,
              value: message.jtlxr
            }
          };
        }
      }
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.textList.title = title;
      this.textList.field = field;
      this.textList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/mode/jtzz.vue